import React from "react";
import styled from "styled-components";
import * as fonts from "../styles/fonts";

function ContactUS() {
  return (
    <div style={{ marginLeft: "1em" }}>
      <RadioButton>Contact Us</RadioButton>
    </div>
  );
}

const RadioButton = styled.button`
  appearance: none;
  position: relative;
  z-index: 1;
  border: none;
  background-color: #fff;
  border: 2px solid #0de49d;
  line-height: 3em;
  padding: 0px 2.1875em;
  font-size: 0.96em;
  text-transform: uppercase;
  text-align: center;
  font-weight: 500;
  border-radius: 6px;
  color: #0de49d;
  min-width: 11.625em;
  font-family: ${fonts.three};

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 1.96em;

    background-color: #0de49d;
    transition: all 0.3s ease-in-out;
    transform: scale(0, 1);
    z-index: -1;
  }

  &:hover {
    color: #fff;
    &:before {
      transform: scale(1) !important;
    }
  }
`;

export default ContactUS;
